<template>
  <modal-cmp class="ProductModalCmp" data-name="product-images-modal">
    <div class="modal-content">
      <span class="title n-heading-3">
        <slot name="title" />
      </span>
      <div class="slider-container">
        <slider-cmp-extended
          :key="dataKey"
          :data-bootstrap-container-classes="['container-fluid', 'px-0']"
          :data-component-slides="true"
          :data-options="{
            observer: true,
            slidesPerView: 1,
            initialSlide: dataInitialSlide,
          }"
          @click.native="closeProductImagesModal"
        >
          <template #custom-swipe-icon>
            <svg>
              <use href="#icon-minus" />
            </svg>
          </template>
          <template #components>
            <slot name="product-images-modal" />
          </template>
        </slider-cmp-extended>
      </div>
    </div>
  </modal-cmp>
</template>

<script>
import ModalCmp from './modal-cmp';
import SliderCmpExtended from './slider-cmp-extended';

export default {
  name: 'ProductModalCmp',
  components: { ModalCmp, SliderCmpExtended },
  props: {
    dataKey: {
      type: Number,
      default: 0,
    },
    dataInitialSlide: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    closeProductImagesModal(event) {
      if (
        !event.target.closest(
          '.swiper-button-prev, .swiper-button-next, .swiper-pagination'
        )
      ) {
        this.$modal.hide('product-images-modal');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductModalCmp {
  --modal-bg-color: #{$color-white};
  --modal-content-separator-color: #{$color-grey-800-50};
  --modal-close-color: #{$color-blue};
  --modal-close-hover-color: #{$color-grey-400-75};

  ::v-deep .modal-box {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-up(md) {
      display: block;
    }
  }

  ::v-deep .SliderCmpExtended {
    --slider-custom-swipe-icon-bg-color: #{$color-blue-10};
    --slider-custom-swipe-icon-width: 24px;
    --slider-custom-swipe-icon-height: 24px;

    .swiper-wrapper {
      align-items: center;
    }

    .swiper-slide {
      .ImageCmp {
        width: 100%;
        height: auto;
      }
    }
    .custom-swipe-icon {
      background-color: var(--slider-custom-swipe-icon-bg-color);
      padding: 20px;
    }
  }

  .modal-content {
    padding: 32px 30px;
    background-color: $color-white;
    color: $color-blue;

    @include media-breakpoint-up(md) {
      padding: 40px 16px;
    }

    @include media-breakpoint-up(lg) {
      padding: 32px 24px 40px;
    }

    .title {
      display: block;
      text-align: left;
      padding: 0 10px 40px;

      @include media-breakpoint-up(md) {
        padding: 0 0 40px;
      }

      @include media-breakpoint-up(lg) {
        padding: 0 0 48px;
      }

      @include media-breakpoint-up(xl) {
        padding: 0 0 56px;
      }
    }
  }
}
</style>
